import React, { FC, memo, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText } from '@mui/material';

import { ParamsProps } from 'src/app/common/components/ParamsProvider';

type ComponentProps = ParamsProps & {
  onCancel: () => void;
  onOk?: () => void;
  open: boolean;
  title?: string;
  content?: string;
};

export const SubmitAlertComponent: React.FC<ComponentProps> = memo((props: ComponentProps) => {
  const { open, onCancel, content, title } = props;
  // i18n
  const intl = useIntl();
  const t = (id: string) => intl.formatMessage({ id });

  return (
    <Dialog
      maxWidth="xs"
      open={open}
      onClose={onCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{title || t('Common.error')}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">{content || t('subsegment.add.agent')}</DialogContentText>
      </DialogContent>
      <DialogActions className="tw-mb-4 tw-mr-4">
        <Button onClick={onCancel} variant="outlined" color="inherit">
          {t('Common.close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
});
